import React, { useEffect } from "react";
import { convertBufferToBlobUrl, viewPDF } from "../../utils/pdf.utils";
import {
  ALIGN_ITEMS,
  CURSOR,
  DISPLAY,
  FONT_SIZE,
  FONT_WEIGHT,
  JUSTIFY_CONTENT,
  SPACING,
} from "../../Constants/Enums/styles.enum";
import { Colors } from "../../Constants/colors";

import { HoverInListener } from "../HoverListener/HoverInListener";
import HoverAwayListener from "../HoverListener/HoverAwayListner";

export const BufferView = ({
  buffer,
  fileName,
}: {
  buffer: number[] | { data: number[] } | Buffer | any;
  fileName: string;
}) => {
  const [bufferUrl, setBufferUrl] = React.useState<string | null>(null);

  const [isHovered, setIsHovered] = React.useState(false);

  useEffect(() => {
    const url = convertBufferToBlobUrl(buffer);
    if (url) {
      setBufferUrl(url);
    }

    return () => {
      if (url) {
        URL.revokeObjectURL(url);
      }
    };
  }, [buffer]);

  if (!bufferUrl) {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: DISPLAY.FLEX,
          alignItems: ALIGN_ITEMS.CENTER,
          justifyContent: JUSTIFY_CONTENT.CENTER,
          color: Colors.Midgrey,
        }}
      >
        Loading preview...
      </div>
    );
  }

  const handleViewCertificate = () => {
    viewPDF(buffer, fileName);
  };

  return (
    <HoverInListener onHoverIn={setIsHovered.bind(null, true)}>
      <HoverAwayListener onHoverAway={setIsHovered.bind(null, false)}>
        <div
          onClick={handleViewCertificate}
          style={{
            width: "100%",
            height: "240px",
            borderRadius: SPACING.S8,
            overflow: "hidden",
            border: `1px solid ${isHovered ? Colors.Midgrey : Colors.LightGrey}`,
            cursor: CURSOR.POINTER,
            position: "relative",
            backgroundColor: Colors.White,
            transition: "all 0.3s ease",
            boxShadow: isHovered
              ? "rgba(0, 0, 0, 0.1) 0px 4px 12px"
              : "rgba(0, 0, 0, 0.04) 0px 2px 4px",
          }}
        >
          <iframe
            src={`${bufferUrl}#toolbar=0&navpanes=0&scrollbar=0&view=FitH`}
            style={{
              width: "calc(100% + 20px)",
              height: "calc(100% + 20px)",
              border: "none",
              pointerEvents: "none",
              position: "absolute",
              top: "-10px",
              left: "-10px",
            }}
            title={fileName}
          />
          {/* Overlay for click */}
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: isHovered
                ? "linear-gradient(to bottom, rgba(0, 0, 0, 0.02), rgba(0, 0, 0, 0.15))"
                : "transparent",
              transition: "background 0.3s ease",
              display: DISPLAY.FLEX,
              alignItems: ALIGN_ITEMS.CENTER,
              justifyContent: JUSTIFY_CONTENT.CENTER,
            }}
          >
            {isHovered && (
              <div
                style={{
                  display: DISPLAY.FLEX,
                  alignItems: ALIGN_ITEMS.CENTER,
                  gap: SPACING.S8,
                  padding: `${SPACING.S10} ${SPACING.S16}`,
                  backgroundColor: "rgba(255, 255, 255, 0.95)",
                  color: Colors.DarkGrey,
                  borderRadius: SPACING.S8,
                  fontWeight: FONT_WEIGHT.SEMI_BOLD,
                  fontSize: FONT_SIZE.F14,
                  boxShadow: "rgba(0, 0, 0, 0.12) 0px 4px 16px",
                  border: `1px solid ${Colors.LightGrey}`,
                  cursor: CURSOR.POINTER,
                  transition: "all 0.2s ease",
                }}
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <span>Click to expand</span>
              </div>
            )}
          </div>
        </div>
      </HoverAwayListener>
    </HoverInListener>
  );
};
